import React, { PureComponent } from 'react';

import Card from '@bit/wavfichacerta.fichacerta.cards.card';
import { BaseColumn } from '@bit/wavfichacerta.fichacerta.shared-styles.columns';
import { StyledRow } from '@bit/wavfichacerta.fichacerta.shared-styles.rows';
import RenderFields from '../../shared/RenderFields';
import RenderServicesFields from './RenderServicesFields';
import { ComercialInterestInner } from './comercialData.styled';

import interestFields from './interestFields';
import servicesFields from './servicesFields';

class InterestSection extends PureComponent {

  renderLeftContent = () => {
    const { initialValues, master } = this.props;
    const hasIndication = initialValues.como_conheceu === "INDICACAO"? true : false;
    const fields = interestFields(hasIndication, master);
    
    return <RenderFields fields={fields} />;
  }

  renderRightContent = () => {
    return <RenderServicesFields fields={servicesFields} master={this.props.master} />;
  }

  render() {
    return (
      <StyledRow margin="1rem 0 0 0">
        <BaseColumn sm={12} padding="0" margin="0">
          <Card
            className="comercial-data-card comercial-data-interest-card"
            title="Informações comerciais"
            padding="1rem 1rem 0.75rem 1rem"
          >
            <ComercialInterestInner className="comercial-data-interest">
              <BaseColumn
                className="comercial-data-interest-col"
                sm={12}
                md={12}
                lg={12}
                xl={12}
                align="flex-start"
                margin="0 0 0.65rem 0"
              >
                {this.renderLeftContent()}
              </BaseColumn>
              <BaseColumn
                className="comercial-data-services-col"
                sm={12}
                md={12}
                lg={12}
                xl={12}
                margin="0"
              >
                <div className="comercial-data-services">
                  {this.renderRightContent()}
                </div>
              </BaseColumn>
            </ComercialInterestInner>
          </Card>
        </BaseColumn>
      </StyledRow>
    );
  }
}

export default InterestSection;
